import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { Col, Label, FormGroup } from 'reactstrap';
import TranslatableField from '../../../../TranslatableField/TranslatableField';
import FilmSectionsField from '../../../../FilmSectionsField/FilmSectionsField';

const SETTING_FORM = 'settingForm';
const valueSelector = formValueSelector(SETTING_FORM);

const SectionSettings = ({ env, screen, widget }) => {
    const { t } = useTranslation();
    const { filmSectionOptions, isLoadingFilmSectionOptions } = useSelector(state => state.sections);

    const sectionBaseName = `mobile.${env}.screens.${screen}.widgets[${widget.index}].section`;
    const sectionId = useSelector(state => valueSelector(state, `${sectionBaseName}.id`));
    const selectedOption = (filmSectionOptions || []).find(option => option.id === sectionId);

    return (
        <>
            <FormGroup row className="widget-setting">
                <Label className="col-sm-4">
                    { t('settings.mobile.screens.widget.settings.section_id') }
                </Label>
                <Col sm={ 8 }>
                    <FilmSectionsField
                        name={ `${sectionBaseName}.id` }
                        sectionBaseName={ sectionBaseName }
                        filmSectionOptions={ filmSectionOptions }
                        isLoading={ isLoadingFilmSectionOptions }
                    />
                    { selectedOption?.source === 'eventival' && (
                        <small className="form-text text-muted">
                            { t('settings.mobile.screens.widget.settings.section_eventival_hint') }
                        </small>
                    ) }
                    { selectedOption?.source === 'engine' && (
                        <small className="form-text text-muted">
                            { t('settings.mobile.screens.widget.settings.section_engine_hint') }
                        </small>
                    ) }
                </Col>
            </FormGroup>
            <FormGroup row className="widget-setting">
                <Label className="col-sm-4">
                    { t('settings.mobile.screens.widget.settings.section_name') }
                </Label>
                <Col sm={ 8 }>
                    <TranslatableField
                        component="input"
                        name={ sectionBaseName }
                    />
                </Col>
            </FormGroup>
        </>
    );
};

export default SectionSettings;
